import Immutable from "immutable";

export default {
    CLEAR_WIDGETS_DATA: (state, action) => {
        var cachedWidgets = action.payload.cachedWidgets;

        return state.filter((widgetData, widgetKey) => {
            return cachedWidgets[widgetKey];
        });
    },
    CLEAR_WIDGET_DATA: (state, action) => {
        var widgetId = action.payload.widgetId;
        let stateFilter = state.filter((widgetData, widgetKey) => {
            return widgetKey !== widgetId;
        });

        return stateFilter;
    },
    WIDGET_DATA_UPDATE: (state, action) => {
        var widgetId = action.payload.widget;
        //using mergeIn instead of setIn to retain info such as parentWidget
        return state.mergeIn([widgetId], Immutable.fromJS(action.payload));
    },
    WIDGET_DATA_SUCCESS: (state, action) => {
        var widgetId = action.payload.widget;
        var parentWidget = action.payload.parentWidget;
        var newState = state;

        //using mergeIn instead of setIn to retain info such as parentWidget
        newState = newState.mergeIn([widgetId], Immutable.fromJS(action.payload));

        //setting parentWidget if provided
        //usecase: actions such as "processStep" that require action on a parentWidget
        if (parentWidget) {
            newState = newState.mergeIn([widgetId], {
                parentWidget: parentWidget
            });
        }

        return newState;
    },
    WIDGET_UPDATE_ENTITY_SUCCESS: (state, action) => {
        var destinationPaths = action.payload.destinationPaths || [];

        var newData = Object.assign({}, action.payload);

        delete newData.widget;
        delete newData.destinationPaths;

        return state.withMutations(state => {
            destinationPaths.forEach(path => {
                state.mergeIn(path, newData);
            });
        });
    },
    SET_WIDGET_STATE: (state, action) => {
        let widgetId = action.payload.widget;
        let widgetState = action.payload.state;
        return state.mergeIn([widgetId, "widgetState"], Immutable.fromJS(widgetState));
    }
};
